/* Instagram reels - video only.

   Plays each reel silently on loop while it is on screen and pauses it when
   it leaves, so nothing downloads or keeps decoding out of view. Autoplay is
   only allowed while muted, so the sound button is the one thing that turns
   audio on, and unmuting one reel mutes the rest. */

(function () {
  'use strict';

  var reduceMotion =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function videosIn(root) {
    return Array.prototype.slice.call(root.querySelectorAll('[data-ct-reel] video'));
  }

  function play(video) {
    var attempt = video.play();
    /* Browsers reject autoplay in conditions this code cannot detect up front
       (battery saver, an OS setting, no user gesture yet). Nothing to recover
       here - the poster frame stays up, which is a reasonable still. */
    if (attempt && typeof attempt.catch === 'function') {
      attempt.catch(function () {});
    }
  }

  function muteAllExcept(keep) {
    videosIn(document).forEach(function (video) {
      if (video === keep) return;
      video.muted = true;
      var button = video.closest('[data-ct-reel]').querySelector('[data-ct-reel-sound]');
      if (button) {
        button.setAttribute('aria-pressed', 'false');
        button.setAttribute('aria-label', 'Turn sound on');
      }
    });
  }

  function wireSound(root) {
    var buttons = root.querySelectorAll('[data-ct-reel-sound]');

    Array.prototype.forEach.call(buttons, function (button) {
      button.addEventListener('click', function (event) {
        /* The whole card is wrapped in a link to the reel; this button sits
           on top of it and must not follow it. */
        event.preventDefault();
        event.stopPropagation();

        var card = button.closest('[data-ct-reel]');
        var video = card && card.querySelector('video');
        if (!video) return;

        var turningOn = video.muted;
        if (turningOn) muteAllExcept(video);

        video.muted = !turningOn;
        button.setAttribute('aria-pressed', turningOn ? 'true' : 'false');
        button.setAttribute('aria-label', turningOn ? 'Turn sound off' : 'Turn sound on');

        /* A tap on the sound button counts as the gesture that lets a paused
           video start, so honour it even when autoplay never ran. */
        if (video.paused) play(video);
      });
    });
  }

  function watch(root) {
    var videos = videosIn(root);
    if (!videos.length) return;

    videos.forEach(function (video) {
      /* Inline playback on iOS, which otherwise takes the video fullscreen
         the moment it plays. */
      video.muted = true;
      video.playsInline = true;
      video.setAttribute('playsinline', '');
      video.setAttribute('webkit-playsinline', '');
      video.loop = true;
      video.controls = false;
    });

    if (reduceMotion || !('IntersectionObserver' in window)) return;

    /* Resolved per video, not from `root`: on first load root is the document,
       which has no section to read the setting off, and a page can hold more
       than one reels section with different settings. */
    var autoplaying = videos.filter(function (video) {
      var section = video.closest('[data-ct-reels]');
      return section && section.hasAttribute('data-autoplay');
    });

    if (!autoplaying.length) return;

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          var video = entry.target;
          if (entry.isIntersecting) {
            /* Held at preload="none" in the markup so an off-screen row costs
               nothing; the source is only fetched once it is actually needed. */
            if (video.preload === 'none') video.preload = 'auto';
            play(video);
          } else {
            video.pause();
          }
        });
      },
      { threshold: 0.4 }
    );

    autoplaying.forEach(function (video) {
      io.observe(video);
    });
  }

  function init(root) {
    var scope = root || document;
    watch(scope);
    wireSound(scope);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  /* The theme editor throws away and re-renders a section on every change. */
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();